<template>
  <div class="">
    <el-form class="form-inline" :inline="true">
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入姓名/手机号" size="small" clearable>
          <el-button slot="append" class="iv-search" size="small" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        @selection-change="selectNews"
        ref="rfTable"
        style="width: 100%;"
        size="mini">
      <el-table-column v-if="type == 2"
         type="selection"
         align="center"
         width="55">
      </el-table-column>
      <el-table-column
          prop="user_id"
          label="会员ID">
      </el-table-column>
      <el-table-column
          prop="name"
          label="昵称"
          align="center">
      </el-table-column>
      <el-table-column
          prop="avatar"
          label="头像"
          align="center">
        <template slot-scope="scope">
          <el-avatar :size="40" shape="square" :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          width="120">
      </el-table-column>
      <!--      <el-table-column-->
      <!--              prop="tweeter_up"-->
      <!--              label="上上级"-->
      <!--              align="left"-->
      <!--              width="200">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div v-if="scope.row.tweeter_up" style="display: flex; align-items: center">-->
      <!--            <el-avatar :size="40" shape="square" :src="scope.row.tweeter_up.avatar" class="mg-rt-10"></el-avatar>-->
      <!--            <div>{{scope.row.tweeter_up.name}}<br>{{scope.row.tweeter_up.user_id}}</div>-->
      <!--          </div>-->
      <!--          <div v-else>-</div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          prop="grade_name"-->
      <!--          label="会员卡"-->
      <!--          align="center"-->
      <!--          width="120">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          prop="grade_over_time"-->
      <!--          label="到期时间"-->
      <!--          align="center"-->
      <!--          width="150">-->
      <!--      </el-table-column>-->
<!--      <el-table-column-->
<!--          prop="grade_id"-->
<!--          label="VIP"-->
<!--          align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.grade_id==0">-</div>-->
<!--          <div v-else>到期：{{scope.row.grade_over_time}}</div>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
          prop="integral"
          label="积分"
          align="center">
        <template slot-scope="scope">
          ￥{{scope.row.balance}}
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="balance"-->
<!--          label="余额"-->
<!--          align="center">-->
<!--        <template slot-scope="scope">-->
<!--          ￥{{scope.row.balance}}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
          prop="commission"
          label="业绩"
          align="center">
        <template slot-scope="scope">
          ￥{{scope.row.commission}}
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="integral"-->
      <!--          label="积分"-->
      <!--          align="center"-->
      <!--          width="120">-->
      <!--      </el-table-column>-->
      <el-table-column
          prop="tweeter"
          label="上级"
          align="left"
          width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.tweeter" style="display: flex; align-items: center">
            <el-avatar :size="40" shape="square" :src="scope.row.tweeter.avatar" class="mg-rt-10"></el-avatar>
            <div>{{scope.row.tweeter.name}}<br>{{scope.row.tweeter.user_id}}</div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="grade_name"
          label="会员身份"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="注册时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column v-if="type == 1"
         fixed="right"
         label="选择"
         align="center"
         width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="small" @click="selectRow(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="changePage"
        layout="total, prev, pager, next"
        :page-size="search.limit"
        :total="search.total">
    </el-pagination>
    <el-button type="primary" size="small" @click="chooseOk()" style="position: absolute; bottom: 35px; left: 20px;" v-if="type == 2">确定</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: {
        current_page: 1,
        total: 0,
        limit: 5,
        keywords: ''
      },
      tableData: [],
      chooseList: []
    }
  },
  components: {},
  props: {
    selectFunc: Function,
    idx: Number,
    type: Number // 1-单选，2-多选
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  methods: {
    getList() {
      var _this = this
      _this.showLoading()
      var param = {
        page: _this.search.current_page,
        page_size: _this.search.limit,
        keywords: _this.search.keywords
      }
      this.$api.member.memberIndex(param, function (res) {
        _this.hideLoading()
        if (res.errcode == 0) {
          _this.tableData = res.data.data
          _this.search.current_page = res.data.current_page
          _this.search.total = res.data.total
        } else {
          _this.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    changePage(page) {
      this.search.current_page = page
      this.getList()
    },
    selectRow(row) {
      this.selectFunc(row)
    },
    selectNews(data) {
      this.chooseList = data
    },
    // 多选操作
    chooseOk() {
      if (this.chooseList.length < 1) {
        this.fail('请选择会员')
      } else {
        this.selectFunc(this.chooseList)
      }
    }
  }
}
</script>

<style scoped>
</style>
